/*
Objetivo: Componente del nombre de un curso 
Utilizacion: se usa en FormCurso
*/

import { Input,  } from 'mdbreact';
import React  from 'react';

import {  inject, observer,    } from "mobx-react"
import ErrorValidacion from '../../layout/ErrorValidacion' 

const ComponenteCorreoUsuario = (props) => {
  const {
    icon, 
    label, 
    type, 
    value, 
    error,
    deshabilitado,
  } = props.store.inputCorreoUsuario.getPropiedades()

    return (
    <div>
      <Input 
        icon = {icon}
        label = {label}
        type = {type}
        value = {value}
        onChange={ (e) => props.store.inputCorreoUsuario.setValor(e.target.value) }

        onBlur = {event => { 
          if (event.dispatchConfig.dependencies ==   'blur') { 
            props.store.inputCorreoUsuario.validar()
        }}}
      />
      <ErrorValidacion error={error}/>

    </div>
  )
}

export  default inject("store")( observer( ComponenteCorreoUsuario ) )
